<template>
    <div >


        <b-form-group
                v-click-outside="nameOfCustomEventToCall_1"
                class="form-group-sm">

            <input
                    id="maskedDateFrom_input"
                    class="form-control full-width masked_date_input_1 form-control"
                    type="text"
                    @keyup="maskedDateFromHandler"
                    v-model="maskedDateFrom"
                    v-mask="{mask: '99.99.9999', greedy: false}">
            <label class="form-label">Датум од</label>
            <!--                                @selected=""-->
            <datepicker
                    ref="datepickmask_1"
                    id="date_pick_1"
                    :typeable="true"
                    :disabledDates="disabledDatesFrom"
                    :full-month-name="true"
                    format="dd.MM.yyyy"
                    v-model="form.dateFrom"
                    input-class="form-control full-width date_input_1"
                    :calendar-button="true"
                    calendar-button-icon="icon-calendar1"
                    :clear-button="true"
                    clear-button-icon="icon-x"
                    :bootstrap-styling="true"
                    :language="srCYRL">
            </datepicker>
            <div class="form-error" v-if="invalidDateFrom">Датум није у исправном формату</div>
        </b-form-group>
        <b-form-group
                v-click-outside="nameOfCustomEventToCall_2"
                class="form-group-sm">
            <label class="form-label">Датум до</label>
            <input

                    id="maskedDateTo_input"
                    class="form-control full-width masked_date_input_1 form-control"
                    type="text"
                    @keyup="maskedDateToHandler"
                    v-model="maskedDateTo"
                    v-mask="{mask: '99.99.9999', greedy: false}">

            <datepicker
                    ref="datepickmask_2"
                    id="date_pick_2"
                    :disabledDates="disabledDatesTo"
                    :full-month-name="true"
                    format="dd.MM.yyyy"
                    v-model="form.dateTo"
                    input-class="form-control full-width date_input_1"
                    :calendar-button="true"
                    calendar-button-icon="icon-calendar1"
                    :clear-button="true"
                    clear-button-icon="icon-x"
                    :bootstrap-styling="true"
                    :language="srCYRL">
            </datepicker>
            <div class="form-error" v-if="invalidDateTo">Датум није у исправном формату</div>
        </b-form-group>
    </div>

</template>

<script>
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import {srCYRL} from 'vuejs-datepicker/dist/locale'

    export default {
        name: "DataPickerMaskComponent",
        data() {
            return {

                maskedDateFrom: null,
                maskedDateTo: null,
                srCYRL: srCYRL,
                form: {
                    dateFrom: null,
                    dateTo: null,
                },
            }

        },
        props: {
            setDateFrom:{
                default: null,
                type: String
            },
            setDateTo:{
                default: null,
                type: String
            },
        },
        components: {
            Datepicker,
        },
        computed: {
            datefrom() {
                if (this.form.dateFrom) {
                    return moment(this.form.dateFrom).format('YYYYMMDD') + '000000';
                } else {
                    return null
                }
            },
            dateto() {
                if (this.form.dateTo) {
                    return moment(this.form.dateTo).format('YYYYMMDD') + '235959';
                } else {
                    return null
                }
            },
            disabledDatesFrom: function () {
                if (this.form.dateTo === null) {
                    // console.log('from disabledDatesFrom true');
                    return {from: new Date}
                } else  {
                    // console.log('from disabledDatesFrom false: ', this.form.dateTo);
                    return {from: new Date(this.form.dateTo)}
                }
            },
            disabledDatesTo: function () {
                // console.log('vebore disabledDatesTo');
                if (this.form.dateFrom === null) {
                    // console.log('from disabledDatesTo true');
                    return {from: new Date}
                } else  {
                    // console.log('from disabledDatesTo false');
                    return   {to:  new Date(this.form.dateFrom) , from: new Date}
                }
            },
            invalidDateFrom: function () {
                return (this.maskedDateFrom !== null && this.maskedDateFrom !== '' &&
                        !this.maskedDateFrom.includes("_") && !moment(this.maskedDateFrom, 'DD.MM.YYYY').isValid())
            },
            invalidDateTo: function () {
                return (this.maskedDateTo !== null && this.maskedDateTo !== '' &&
                        !this.maskedDateTo.includes("_") && !moment(this.maskedDateTo, 'DD.MM.YYYY').isValid())
            }
        },
        watch: {
            'form.dateFrom': function () {
                if (this.form.dateFrom !== null) {
                    var date = moment(this.form.dateFrom);
                    this.maskedDateFrom = date.format('DD.MM.YYYY');
                    this.emitDateFrom(date.toISOString());
                } else {
                    this.maskedDateFrom = null;
                    this.emitDateFrom(null);
                }
            },
            'form.dateTo': function () {
                if (this.form.dateTo !== null) {
                    var date = moment(this.form.dateTo);
                    this.maskedDateTo = date.format('DD.MM.YYYY');
                    this.emitDateTo(date.toISOString());
                } else {
                    this.maskedDateTo = null;
                    this.emitDateTo(null);
                }
            }
        },
        methods: {

            resetDate(from=null, to=null){
                if(from && to){
                    console.log("from: ", from);
                    // this.form.dateFrom = from;
                    // this.form.dateTo = to;
                    this.maskedDateFrom = moment(from, 'YYYY-MM-DD').format('DD.MM.YYYY');
                    this.emitDateFrom(moment(from, 'YYYY-MM-DD').toISOString());

                    this.maskedDateTo = moment(to, 'YYYY-MM-DD').format('DD.MM.YYYY');
                    this.emitDateTo(moment(to, 'YYYY-MM-DD').toISOString());




                } else {
                    console.log('Reset');
                    this.$refs.datepickmask_1.clearDate();
                    this.$refs.datepickmask_2.clearDate();
                }
                // this.$refs.datepickmask_1.clearDate();
                // this.$refs.datepickmask_2.clearDate();

              // console.log("reset from CHILD");
            },
            // nameOfCustomEventToCall(){
            //
            // },
            nameOfCustomEventToCall_1: function () {
                this.$refs.datepickmask_1.close();



                // this.$refs.datepick.hideCalendar();
                // console.log('OUTSIDE event', event);
            },
            nameOfCustomEventToCall_2: function () {
                this.$refs.datepickmask_2.close();


                // this.$refs.datepick.hideCalendar();
                // console.log('OUTSIDE event', event);
            },
            maskedDateFromHandler() {
                if (this.maskedDateFrom && !this.maskedDateFrom.includes("_") && moment(this.maskedDateFrom, 'DD.MM.YYYY').isValid()) {
                    this.form.dateFrom = moment(this.maskedDateFrom, 'DD.MM.YYYY').format('YYYY-MM-DD');
                }
            },
            maskedDateToHandler() {
                if (this.maskedDateTo && !this.maskedDateTo.includes("_") && moment(this.maskedDateTo, 'DD.MM.YYYY').isValid()) {
                    this.form.dateTo = moment(this.maskedDateTo, 'DD.MM.YYYY').format('YYYY-MM-DD');
                }
            },
            emitDateFrom(date) {
                this.$emit('datapiskerDateFromValue', date)
            },
            emitDateTo(date) {
                this.$emit('datapiskerDateToValue', date)
            }
        },
        mounted() {

            if(this.setDateFrom){
this.form.dateFrom = this.setDateFrom
            }
            if(this.setDateTo){
this.form.dateTo = this.setDateTo
            }


            this.emitDateFrom();
            // maskedDateFrom_input
            let date_pick_1 = document.getElementById('date_pick_1');
            let maskedDateFrom_input = document.getElementById('maskedDateFrom_input');
            date_pick_1.inputmask = maskedDateFrom_input.inputmask;
            date_pick_1.parentNode.append(maskedDateFrom_input);

            // maskedDateTo_input
            // date_pick_2
            let date_pick_2 = document.getElementById('date_pick_2');
            let maskedDateTo_input = document.getElementById('maskedDateTo_input');
            date_pick_2.inputmask = maskedDateTo_input.inputmask;
            date_pick_2.parentNode.append(maskedDateTo_input);
        },
    }
</script>

<style>
    .date_input_1 {
        display: none;
    }
</style>
